// 보스 적 클래스 - Warrior 전용
class WarriorEnemy extends Enemy {
  constructor(scene, x = 0, y = 0, z = 0) {
    super(scene, x, y, z, "WARRIOR");

    // 보스 전용: 체력바
    this.healthBar = null;
  }

  // 초기화 오버라이드 (체력바 추가)
  async init() {
    // 부모 클래스의 init 호출
    await super.init();

    // 체력바 생성
    this.healthBar = new HealthBar(this.scene, this);
    this.healthBar.setOffset(0, 6, 0); // 더 높이 표시 (보스는 크니까)
    this.healthBar.updateHealth(this.health, this.maxHealth);
  }

  // 애니메이션 인덱스 정의 오버라이드 (보스는 다른 애니메이션 사용)
  getAnimationIndices() {
    return {
      idle: 42, // 대기 애니메이션
      move: 94, // 걷기 애니메이션
      aim: null, // 조준 애니메이션 없음
      attack: 44, // 공격 애니메이션 (다른 인덱스 사용)
      hit: 38, // 피격 애니메이션
      death: 24, // 죽음 애니메이션
    };
  }

  // 업데이트 오버라이드 (체력바 업데이트 추가)
  update(delta, playerPosition) {
    // 부모 클래스의 update 호출
    super.update(delta, playerPosition);

    // 체력바 업데이트
    if (this.healthBar && window.game?.camera) {
      this.healthBar.update(window.game.camera);
    }
  }

  // 데미지 받기 오버라이드 (체력바 업데이트)
  takeDamage(damage, attackerPosition = null) {
    const result = super.takeDamage(damage, attackerPosition);

    // 체력바 업데이트
    if (this.healthBar) {
      this.healthBar.updateHealth(this.health, this.maxHealth);
    }

    return result;
  }

  // 죽음 처리 오버라이드 (체력바 제거)
  die() {
    super.die();

    // 체력바 숨기기
    if (this.healthBar) {
      this.healthBar.setVisible(false);
    }
  }

  // 씬에서 제거 오버라이드 (체력바도 함께 제거)
  removeFromScene() {
    // 체력바 제거
    if (this.healthBar) {
      this.healthBar.destroy();
      this.healthBar = null;
    }

    // 부모 클래스의 removeFromScene 호출
    super.removeFromScene();
  }

  // 정리 오버라이드
  dispose() {
    // 체력바 제거
    if (this.healthBar) {
      this.healthBar.destroy();
      this.healthBar = null;
    }

    // 부모 클래스의 dispose 호출
    super.dispose();
  }
}

// 전역으로 내보내기
if (typeof module !== "undefined" && module.exports) {
  module.exports = WarriorEnemy;
} else {
  window.WarriorEnemy = WarriorEnemy;
}

// webpack 빌드를 위해 default export 추가
export default WarriorEnemy;